'use client'

import Image from 'next/image'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/v2/ui/table'
import { useTexts } from '@/contexts/LanguageContext'
import type { ITrustCenterSubprocessor } from '@/types/trust-center/trustCenterSubprocessor'

const HEAD_CLASS = 'px-4 text-xs font-medium text-trust-center-muted'

function SubprocessorRow({ subprocessor }: { subprocessor: ITrustCenterSubprocessor }) {
  return (
    <TableRow className="border-trust-center-border text-sm">
      <TableCell className="px-4 py-2.5 font-medium">
        <span className="flex items-center gap-2.5">
          <span className="flex size-7 shrink-0 items-center justify-center rounded border border-trust-center-border bg-white">
            <Image src={subprocessor.logoUrl} alt="" width={18} height={18} className="size-4.5 object-contain" />
          </span>
          {subprocessor.name}
        </span>
      </TableCell>
      <TableCell className="px-4 py-2.5 whitespace-normal text-trust-center-muted">{subprocessor.purpose}</TableCell>
      <TableCell className="px-4 py-2.5 text-trust-center-muted">{subprocessor.location}</TableCell>
    </TableRow>
  )
}

export default function SubprocessorsTable({ subprocessors }: { subprocessors: ITrustCenterSubprocessor[] }) {
  const { SUBPROCESSORS } = useTexts().PUBLIC_TRUST_CENTER
  return (
    <div className="overflow-hidden rounded border border-trust-center-border">
      <Table>
        <TableHeader className="bg-trust-center-subtle">
          <TableRow className="border-trust-center-border hover:bg-transparent">
            <TableHead className={HEAD_CLASS}>{SUBPROCESSORS.PROVIDER}</TableHead>
            <TableHead className={HEAD_CLASS}>{SUBPROCESSORS.PURPOSE}</TableHead>
            <TableHead className={HEAD_CLASS}>{SUBPROCESSORS.LOCATION}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {subprocessors.map((subprocessor) => (
            <SubprocessorRow key={subprocessor.id} subprocessor={subprocessor} />
          ))}
        </TableBody>
      </Table>
      {subprocessors.length === 0 && (
        <p className="p-7 text-center text-sm text-trust-center-muted">{SUBPROCESSORS.EMPTY}</p>
      )}
    </div>
  )
}
